import { Component } from '@angular/core';
import { ClientStatusService } from '@sdbn/common';

@Component({
    selector: 'app-tmc-auth-frame',
    templateUrl: './tmc-auth-frame.component.html',
    styleUrls: ['./tmc-auth-frame.component.scss'],
    standalone: false
})
export class TmcAuthFrameComponent {

  constructor(
    private clientStatusService: ClientStatusService
  ) { }

  vertical = false;

  ngOnInit(): void {
    this.clientStatusService.changed.subscribe(() => {
      console.log('AuthSampleComponent: clientStatusService.changed', this.clientStatusService.isDisplay, this.clientStatusService.isDesktop, this.clientStatusService.isMobile, this.clientStatusService.isTablet);
      this.vertical = this.clientStatusService.isMobile || this.clientStatusService.isTablet;
    });
  }
}
